import { render, staticRenderFns } from "./Error400.vue?vue&type=template&id=991d07b8&scoped=true&lang=pug"
import script from "./Error400.vue?vue&type=script&lang=ts"
export * from "./Error400.vue?vue&type=script&lang=ts"
import style0 from "./Error400.vue?vue&type=style&index=0&id=991d07b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991d07b8",
  null
  
)

export default component.exports